import { useState } from 'react'
import AccessLevel from './AccessLevel'
import AccessLevelModal from 'pages/Modals/AccessLevelModal'

import {
  Container,
  ListContainer,
  SubTitle,
  LabelRow
} from './styles'

export default function AccessLevelList ({
  accessLevels = [],
  permissions = [],
  professionalID = null,
  professionalPermissions = [],
  showLabels = true,
  enableEdit = false,
  onEdit: handleEdit,
  onDelete: handleDelete
}) {
  const [accessLevelData, setAccessLevelData] = useState (null)
  const [showAccessLevelModal, setShowAccessLevelModal] = useState (false)
  
  const editAccessLevel = accessLevel => {
    setAccessLevelData (accessLevel)
    toggleAccessLevelModal ()
  }

  const toggleAccessLevelModal = () => setShowAccessLevelModal (!showAccessLevelModal) 

  return accessLevels.length > 0 && (
    <Container>
      {showLabels && (
        <LabelRow>
          <SubTitle>Nome</SubTitle>
          <SubTitle>Permissões</SubTitle>
          <SubTitle>Ações</SubTitle>
        </LabelRow>
      )}
      <ListContainer>
        {accessLevels.map ((accessLevel, index) => (
          <AccessLevel
            key={index}
            index={index}
            data={accessLevel}
            enableEdit={enableEdit}
            professionalID={professionalID}
            professionalPermissions={professionalPermissions}
            onEdit={editAccessLevel}
            onDelete={handleDelete}
          />
        ))}
      </ListContainer>
      {!!accessLevelData && (
        <AccessLevelModal
          visible={showAccessLevelModal}
          accessLevel={accessLevelData}
          accessLevels={accessLevels}
          permissions={permissions}
          onClose={toggleAccessLevelModal}
          onConfirm={handleEdit}
        />
      )}
    </Container>
  )
}
